<template>
  <v-container fluid>
    <v-timeline dense clipped>
      <v-timeline-item v-if="!readOnly" fill-dot class="white--text mb-0" color="orange" large>
        <template v-slot:icon>
          <span>{{ userAbbr }}</span>
        </template>

        <v-textarea
          auto-grow
          clearable
          solo
          flat
          rows="2"
          clear-icon="mdi-close-circle"
          label="Add a note..."
          v-model="note"
        >
          <template v-slot:append>
            <v-btn class="mx-0" color="primary" outlined @click="addNote">Post</v-btn>
          </template></v-textarea
        >
      </v-timeline-item>

      <v-timeline-item
        class="mb-4"
        fill-dot
        color="red"
        v-if="!todaysNotes.length && !olderNotes.length"
      >
        <template v-slot:icon>
          <span>N</span>
        </template>
        <span>NO NOTES YET...</span>
      </v-timeline-item>

      <v-timeline-item
        class="mb-4"
        hide-dot
        v-if="todaysNotes && todaysNotes.length"
      >
        <span>TODAY</span>
      </v-timeline-item>

      <v-slide-x-transition group>
        <v-timeline-item
          v-for="note in todaysNotes"
          :key="note.id"
          class="mb-4"
          color="primary"
          small
        >
          <v-row justify="space-between">
            <v-col cols="7" class="newlines" v-text="note.note"></v-col>
            <v-col class="text-right" cols="5">
              <v-btn v-if="!readOnly" icon @click="removeNote(note)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
              {{ timestamp(note.created_at) }}</v-col
            >
          </v-row>
        </v-timeline-item>
      </v-slide-x-transition>

      <v-timeline-item
        class="mb-4"
        hide-dot
        v-if="olderNotes && olderNotes.length"
      >
        <span>OLDER</span>
      </v-timeline-item>

      <v-timeline-item
        v-for="note in olderNotes"
        :key="note.id"
        class="mb-4"
        color="accent"
        small
      >
        <v-row justify="space-between">
            <v-col cols="7" class="newlines" v-text="note.note"></v-col>
            <v-col class="text-right" cols="5">
              <v-btn icon @click="removeNote(note)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
              {{ timestamp(note.created_at) }}</v-col
            >
          </v-row>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>

<script>
import moment from "moment";
import { models } from "feathers-vuex";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      note: null,
      notes: this.message.notes || [],
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    todaysNotes() {
      return this.notes.filter((note) => {
        return moment().isSame(note.created_at, "day");
      });
    },
    olderNotes() {
      return this.notes.filter((note) => {
        return !moment().isSame(note.created_at, "day");
      });
    },
    userAbbr() {
      return (
        this.user && this.user.first_name && this.user.last_name ?
        `${this.user.first_name
          .charAt(0)
          .toUpperCase()}${this.user.last_name.charAt(0).toUpperCase()}`
        : this.user && this.user.first_name ? this.user.first_name.charAt(0).toUpperCase() : "AU"
      );
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    timestamp(ts) {
      return moment.duration(moment(ts).diff(moment())).humanize(true);
    },
    async removeNote(_note) {
      const { Note } = models.bot;
      let note = new Note(_note);
      let index = this.notes.findIndex((note) => {
        return note.id === _note.id;
      });

      if (index === -1) return;

      try {
        await note.remove();
        this.notes.splice(index, 1);
      } catch (error) {
        this.showMessage({ text: "Failed to remove note!", color: "error" });
      }
    },
    async addNote() {
      const { Note } = models.bot;

      try {
        let note = new Note({
          message_id: this.message.id,
          user_id: this.user.id,
          note: this.note,
        });
        await note.save();
        this.notes.unshift(note);
        this.note = null;
      } catch (error) {
        this.showMessage({ text: "Your note failed to save!", color: "error" });
      }
    },
  },
  watch: {},
  props: {
    message: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.newlines {
  white-space: pre;
}
</style>